<template>
  <div>
    <h1 class="sm:mb-8 text-center text-2xl lg:text-3xl font-semibold">
      Add team member info
    </h1>
    <section class="flex flex-wrap justify-center">
      <div class="min-w-full sm:min-w-30 max-w-2xl flex-1 m-2">
        <div class="bg-white rounded-lg shadow-card p-8 self-start sm:p-12">
          <div class="sm:flex sm:mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="firstName">First name<small>*</small></label>
              <input type="text" class="input mt-2" id="firstName" v-model="firstName" />
            </fieldset>
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="lastName">Last name<small>*</small></label>
              <input type="text" class="input mt-2" id="lastName" v-model="lastName " />
            </fieldset>
          </div>
          <div class="sm:flex mb-4">
            <fieldset class="flex-1 sm:mr-2 mb-4 sm:mb-0">
              <label for="email">Email<small>*</small></label>
              <input type="email" class="input mt-2" id="email" v-model="email" />
            </fieldset>
            <fieldset class="flex-1 sm:ml-2 mb-4 sm:mb-0">
              <label for="phone">Phone<small>*</small></label>
              <input type="text" class="input mt-2" id="phone" v-mask="'############'" v-model="phone" />
            </fieldset>
          </div>
          <fieldset class="col-start-1 col-end-3">
            <label for="companyName">Company Name</label>
            <input type="text" class="input mt-2" id="companyName" v-model="companyName">
          </fieldset>
          <div class="flex justify-center flex-col-reverse sm:flex-row mt-10">
            <button
              class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-auto sm:flex-none"
              @click="$emit('next')"
              v-if="!canAddAnother"
            >
              Skip
            </button>
            <button
              class="btn btn-secondary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-48 sm:flex-none"
              :disabled="!canSubmit"
              @click="submitTeamMember"
              v-if="canAddAnother"
            >
              <Spinner v-if="loading" class="mx-auto" orange />
              <span v-else>Add Another</span>
            </button>
            <button
              class="btn btn-primary font-semibold rounded px-10 mr-0 sm:mr-4 mt-3 sm:mt-0 w-full sm:w-auto sm:flex-none"
              @click="$emit('next')"
              v-if="canAddAnother"
            >
              Next Step
            </button>
            <button
              class="btn btn-primary font-semibold rounded px-10 w-full sm:w-64 sm:flex-none"
              :disabled="!canSubmit"
              @click="submitTeamMember"
              v-if="!canAddAnother"
            >
              <span v-if="!loading">Add Team Member</span>
              <Spinner class="mx-auto" v-if="loading" />
            </button>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg shadow-card p-8 self-start max-w-sm sm:p-12 m-2">
        <h1 class="mb-3 font-semibold text-lg">
          Helper Info Box
        </h1>
        <p>
          Add team members to your order using this form. Team Members will be able to view and manage some order
          details, such as changing the status or adding attendees. You can add team members here or through the My
          Orders panel.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  import { email, minLength, required } from "vuelidate/lib/validators"
  import Api from "@/api"
  import Spinner from "@/components/common/Spinner"

  const TEXT_FIELD_MIN_LENGTH = 2;

  export default {
    components: {
      Spinner
    },
    data() {
      return {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        companyName: '',
        loading: false,
        canAddAnother: false
      }
    },
    validations: {
      firstName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH),
      },
      lastName: {
        required,
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
      },
      companyName: {
        minLength: minLength(TEXT_FIELD_MIN_LENGTH)
      }
    },
    computed: {
      canSubmit() {
        const { firstName, lastName, email, phone, companyName } = this.$v
        return !firstName.$invalid
          && !lastName.$invalid
          && !email.$invalid
          && !phone.$invalid
          && !companyName.$invalid
      }
    },
    methods: {
      submitTeamMember() {
        this.loading = true
        Api.addCollaboratorToOrder(
          this.$store.state.segmentationOrder.uuid,
          this.firstName,
          this.lastName,
          this.email,
          this.phone,
          this.companyName,
          'team_member'
        ).then(() => {
          this.loading = false
          this.canAddAnother = true
          this.clearForm()

          // Update hasCollaborator field in segmentation order in the store.
          const order = this.$store.state.segmentationOrder
          order.hasCollaborators = true
          this.$store.commit('setSegmentationOrder', order)
        }).catch(() => {
          this.loading = false
        })
      },
      clearForm() {
        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.phone = ''
        this.companyName = ''
      }
    }
  }
</script>